import { useState, useEffect } from 'react';
import Header from './components/Header';
import Calculator from './components/Calculator';
import Benefits from './components/Benefits';
import LeadForm from './components/LeadForm';
import Guarantee from './components/Guarantee';
import Footer from './components/Footer';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header isScrolled={isScrolled} />
      <Calculator />
      <Benefits />
      <LeadForm />
      <Guarantee />
      <Footer />
    </div>
  );
}
